<template>
    <div class="upakovka-card">
        <div class="upakovka-card-img">
            <img :src="card.img" alt="Иконка упаковки" class="upakovka-img" />
            <img v-if="isExpanded" v-for="img in card.detailsImg":src="img" alt="Иконка упаковки" class="upakovka-img" />
        </div>
        <div class="upakovka-card-content">
            <div class="upakovka-card-text">
                <h2 class="upakovka-card-title">
                    {{ card.title }}
                </h2>
                <p class="upakovka-card-subtitle" v-for="subtitle in card.subtitles">
                    {{ subtitle }}
                </p>
            </div>
            <div v-if="card.lists" class="upakovka-card-list">
                <div class="upakovka-card-list-item" v-for="list in card.lists">
                    <img class="upakovka-card-list-img" :src="list.img" alt="Иконка коробки">
                    <p class="upakovka-card-list-text">{{list.text}}</p>
                </div>
            </div>
            <p v-if="card.description" class="upakovka-card-description">
                {{ card.description }}
            </p>
            <div class="upakovka-card-warning" v-if="card.warning">
                <img src="/images/upakovka/icon/warning.svg" alt="Восклицательный знак">
                <p class="upakovka-card-description">
                    {{ card.warning }}
                </p>
            </div>

            <div  class="details-button-wrapper">
                <button v-if="card.info" @click="toggleDetails" class="details-button">
                    {{ isExpanded ? 'Свернуть' : 'Подробнее' }}
                </button>
                <img :src="isExpanded ? '/images/upakovka/icon/arrow_up.svg' : '/images/upakovka/icon/arrow_down.svg'" alt="Иконка стрелки">
            </div>
            <div v-if="isExpanded && card.info" class="details-wrapper">
                <p v-if="card.info.title" class="info-title">
                    {{ card.info.title }}
                </p>
                <p v-if="card.info.subtitle" class="info-title">
                    {{ card.info.subtitle }}
                </p>
                <div v-for="(tableData, tableIndex) in card.info.tables" :key="tableIndex" class="table-group">
                    <h4 v-if="tableData.title" class="table-title">{{ tableData.title }}</h4>
                    <p v-if="tableData.subtitle" class="table-subtitle">{{ tableData.subtitle }}</p>
                    <div class="table-container">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(head, headIndex) in tableData.head" :key="headIndex">
                                        <span v-if="typeof head === 'string'">{{ head }}</span>
                                        <span v-else v-html="head.html"></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, rowIndex) in tableData.rows" :key="rowIndex">
                                    <td v-for="(item, itemIndex) in row" :key="itemIndex" :rowspan="item && item.rowspan" :colspan="item && item.colspan">
                                        <span v-if="typeof item === 'string'">{{ item }}</span>
                                        <span v-else-if="item.html" v-html="item.html"></span>
                                        <span v-else-if="item.text">{{ item.text }}</span>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot v-if="tableData.footer">
                                <tr>
                                    <td :colspan="tableData.head.length" v-html="tableData.footer"></td>
                                </tr>
                            </tfoot>
                        </table>
                        <div v-if="tableData.additionalHtml" v-html="tableData.additionalHtml" class="additional-content"></div>
                    </div>
                </div>
                <div v-if="card.info.additionalHtml" v-html="card.info.additionalHtml" class="additional-content"></div>
            </div>
        </div>
     </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    card: {
        type: Object,
        required: true,
    },
});

const isExpanded = ref(false);

const toggleDetails = () => {
    isExpanded.value = !isExpanded.value;
}
</script>

<style scoped>
.upakovka-card {
    padding: 40px;
    display: flex;
    gap: 32px;
    align-items: flex-start;
    background-color: #F5F5F5;
    border-radius: 20px;

     @media screen and (max-width: 1279px) {
        flex-direction: column;
    }
}

.upakovka-card-img {
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: all 0.5s
}

.upakovka-card-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}

.upakovka-card-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
}

.upakovka-card-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 24px;
    leading-trim: NONE;
    line-height: 32px;
    letter-spacing: 0%;
    margin: 0;
}

.upakovka-card-subtitle {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}

.upakovka-card-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.upakovka-card-list-item {
    padding: 12px 16px;
    display: flex;
    gap: 8px;
    align-items: center;
    background-color: #FFFFFF;
    border-radius: 20px;
}

.upakovka-card-list-text {
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}

.upakovka-card-description {
    font-weight: 700;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}

.upakovka-card-warning {
    display: flex;
    align-items: center;
    gap: 12px;
}

.details-button-wrapper {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;
}

.details-button {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    border: none;
    background-color: transparent;
    color: #48538B;
    cursor: pointer;
    padding: 0;
    text-align: left;
    transition: all 0.5s
}
.details-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    transition: all 0.5s
}

.details-wrapper p {
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
    margin: 0;
}

.info-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
    margin-bottom: 16px;
}

.table-group {
    margin-bottom: 24px;
}

.table-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 20px;
}

.table-subtitle {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 20px;
}

.table-container {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
    min-width: 955px;
}

th, td {
    border: 1px solid #e4e6e7;
    padding: 12px 16px;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    text-align: left;
    word-break: break-word;
    vertical-align: top;
    max-width: 340px;
}

tfoot td {
    border: none;
    text-align: left;
    font-weight: 400;
    font-style: Italic;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    background-color: #f5f5f5;
}

th:first-child,
td:first-child {
    min-width: 80px;
}

th {
    background-color: #F9F9F9;
    font-weight: 500;
}

td {
    background-color: #FFFFFF;
}

.additional-content {
    margin-top: 24px;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 0%;
}

.additional-content ul li {
    list-style-type: square;
    color: #E4003C;
}

@media screen and (max-width: 1279px) {
    table {
        overflow-x: scroll;
    }

    .upakovka-card {
        padding: 24px;
    }

    .upakovka-card-img {
        flex-direction: row;
        flex-wrap: wrap;
    }
}

@media screen and (max-width: 1279px) {
    .upakovka-img {
        width: 120px;
        height: 120px;
    }
}
</style>